import React, { useState, useCallback, useEffect, useRef } from 'react'
import { connect } from "react-redux"
import VideoDisplay from '../video/responsiveVideoPage'
import { Col, Row } from "react-bootstrap"
import { bindActionCreators } from 'redux'
import { cancelAssessmentById, resumeAssessmentById, pauseAssessmentById, startAssessment } from "../../actions/assessment.action"
import { MODALS } from "../../shared/constants/actions.constants"
import { setModalWithType } from "../../actions/modal.action"
import { connectAssessmentNamespaceSocket } from "../../sockets/assessments"
import { getHmdDeviceById, setHmdDeviceById } from "../../actions/hmdDevices.action"
import EyeGraph from '../initiateAssessment/graphs/eyeGraph'
import { stopVFTById } from '../../actions/assessment.action'
import { ASSESSMENT_STATUSES, PAUSE_BY_DEVICE_STATUSES } from '../../shared/constants/shared.constants'
import { getAssessmentById } from '../../actions/assessment.action'

export const HomePanel = ({ history, ...props }) => {
  let idTestPause = props.assessment && 
    (props.assessment.status === ASSESSMENT_STATUSES.PAUSED || props.assessment.status === ASSESSMENT_STATUSES.BLIND_SPOT_FAILURE ||
        PAUSE_BY_DEVICE_STATUSES.includes(props.assessment.status))

  const interval = useRef();
  const [hmdInfo, setHmdInfo] = useState(null);
  const [patientInfo, setPatientInfo] = useState(null);
  const [assessmentInfo, setAssessmentInfo] = useState(null);
  const [isTrialInProgress, setIsTrialInProgress] = useState(false);
  const [socketInfo, setSocketInfo] = useState(null);

  useEffect(()=>{
    props.setModalWithType(true, MODALS.SELECT_HMD_MODAL, {
      backdrop: 'static',
    })
  }, [])

  useEffect(()=>{
    if(props.hmdDeviceList && props.selectedHmdDevice){
      let isSelected = false;
      for (var i = 0; i < props.hmdDeviceList.length; i++) {
        if(props.selectedHmdDevice === props.hmdDeviceList[i].id){
          setHmdInfo(props.hmdDeviceList[i]);
          setPatientInfo(props.hmdDeviceList[i].patient);
          setAssessmentInfo(props.hmdDeviceList[i].assessment);
          if(props.hmdDeviceList[i].patient && props.hmdDeviceList[i].assessment){
            isSelected = true;
          }
          props.getHmdDeviceById(props.hmdDeviceList[i].id);
          break;
        }
      }
      if(!isSelected && props.hmdDeviceList[i]){
        getHmdDetailsByPolling(props.hmdDeviceList[i].id)
      }
    }
  }, [props.selectedHmdDevice])

  useEffect(()=>{
    if(props.trialInProgress !== isTrialInProgress){
      if(!props.trialInProgress && isTrialInProgress){
        if(props.hmdById){
          setPatientInfo(null);
          setAssessmentInfo(null);

          getHmdDetailsByPolling(props.hmdById.id);
          if(socketInfo){
            socketInfo.close()
          }
          props.setHmdDeviceById(null)
        }
      }
      setIsTrialInProgress(props.trialInProgress);
    }
  }, [props.trialInProgress, props.hmdById, socketInfo])

  useEffect(()=>{
    if(props.hmdById && props.hmdById.patient && props.hmdById.assessment){
      // stop polling
      if(interval.current){
        clearInterval(interval.current)
      }

      // set the data
      setPatientInfo(props.hmdById.patient);
      setAssessmentInfo(props.hmdById.assessment);
      setIsTrialInProgress(false);
    }
  }, [props.hmdById])

  const getHmdDetailsByPolling = useCallback(async (id) => {
    if(interval.current){
      clearInterval(interval.current)
    }

    interval.current = setInterval(()=>{
      props.getHmdDeviceById(id)
    }, 2500)

    return () => {
      if(interval.current){
        clearInterval(interval.current)
      }
    }
  }, [])
  const onStopVFT = () => {
    if(props.assessment._id){
      props.stopVFTById(props.assessment._id)
    } else {
      window.location.reload();
    }
  }

  const handleCancel = useCallback(async () => {
    if(assessmentInfo && assessmentInfo.id){
      await props.cancelAssessmentById(assessmentInfo.id)
      window.location.reload();
    }
  }, [assessmentInfo])

  const handlePause = useCallback(async () => {
    if(props.assessment.status === ASSESSMENT_STATUSES.PAUSED){
        await props.resumeAssessmentById(props.assessment._id) 
      } 
      else {
        await props.pauseAssessmentById(props.assessment._id)
      }
  }, [props.assessment])

  const handleStart = useCallback(async () => {
    if(props.hmdAssignedAssessment && props.hmdAssignedAssessment.id )
      await props.startAssessment({ assessmentId: props.hmdAssignedAssessment.id })
      await props.getAssessmentById(props.hmdAssignedAssessment.id)
  }, [props.hmdAssignedAssessment])

  const openCalibrateModal = useCallback(() => {
    props.setModalWithType(true, MODALS.CALIBRATE_MODAL, hmdInfo)
  }, [hmdInfo])

  // socket connection starts here
  useEffect(() => {
    let socket = null;
    if(assessmentInfo && patientInfo && assessmentInfo.id && patientInfo.id){
      socket = connectAssessmentNamespaceSocket(assessmentInfo.id)
    }

    if(socket){
      setSocketInfo(socket);
    }

    return () => {
        if(socket) socket.close()
    }
  }, [patientInfo, assessmentInfo])
  // socket connecttion ends here

  return (
    <div className='overflow-hidden'>
      {
        patientInfo ? (
          <div className="">
            <Row className='pt-2' style={{textAlignLast:"center", padding:"0rem"}}>
              <Col>
                <label>Name</label>: <label value="">{patientInfo?.firstName}{" "}{patientInfo?.lastName}</label>
                <br/>
                <label>DOB</label>: <label value="">{patientInfo?.dateOfBirth}</label>
                <br/>
                <label>Patient ID</label>: <label value="">{patientInfo?.patientId}</label><br />
              </Col>
              <Col className='d-flex flex-column justify-content-center align-items-center'>
                <div>
                  <label>Status</label>: <label>{ props.trialInProgress ? 'Trial in progress' : 'Not in progress'}</label>
                  <br/>
                  <label>HMD ID</label>: <label value="">{hmdInfo?.id}</label><br />
                  <label>{props.assessment && props.assessment?.onGoingTestType === 'left' ? 'Eye being tested: Left': props.assessment?.onGoingTestType === 'right'?'Eye being tested: Right': ''}</label>
                </div>
              </Col>
            </Row>
          </div>
        ) : 

      <div className="">
        <Row style={{textAlignLast:"center", padding:"0"}}>
          <Col>
            <label>Status</label>: <label>{ props.trialInProgress ? 'Trial in progress' : 'Not in progress'}</label>
            <br/>
            <label>HMD ID</label>: <label value="">{hmdInfo?.id}</label><br />
            <br/>
            <label></label>
          </Col>
        </Row>
      </div>
      }

      {/* <br /> */}
      <div className=''>
        <Row>
          <Col className='video' id='video1'>
            <VideoDisplay style={{justifyContent:'center', alignItems:'center'}}>
            </VideoDisplay>
          </Col>
        </Row>
      </div>
      {/* <br /><br /> */}
      <div className='container'>
        <Row style={{textAlignLast:"center", padding:"1rem"}}>
          {/* <Col xs>
              <button type="button" className="btn btn-light btn__white" onClick={openCalibrateModal} disabled={ props.hmdById && props.hmdAssignedAssessment ? false : true }> Calibrate</button>
          </Col> */}
          <Col xs> 
             {props.hmdById && props.hmdAssignedAssessment && props.hmdAssignedAssessment?.status === ASSESSMENT_STATUSES.TRIAL_COMPLETED ? <button type="button" className={`btn btn-light btn__white `} onClick={handleStart} disabled={ props.trialInProgress === true }> Start Test</button> : <button type="button" className = { `btn btn__white with__icon ${ props.assessment && (props.assessment.status === ASSESSMENT_STATUSES.INITIATED || props.assessment.status === ASSESSMENT_STATUSES.PAUSED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_VFT || props.assessment.status === ASSESSMENT_STATUSES.RECALIBRATE) && "disabled" }` } onClick = { onStopVFT } disabled = { props.assessment ? (props.assessment.status === ASSESSMENT_STATUSES.INITIATED || props.assessment.status === ASSESSMENT_STATUSES.PAUSED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_VFT || props.assessment.status === ASSESSMENT_STATUSES.RECALIBRATE): true}>Finish Test</button>}
          </Col>
          <Col xs>
              <button type="button" className = { `btn btn__white with__icon ${ props.assessment && (props.assessment.status === ASSESSMENT_STATUSES.COMPLETED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_QUESTIONNIRE) && "disabled" } ${!!props.assessment?.status == false  && "disabled"} ` } onClick = { handlePause } disabled = { props.assessment && (props.assessment.status === ASSESSMENT_STATUSES.COMPLETED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_QUESTIONNIRE) }><i className = "fabicon-CirclePauseSolid"></i> { idTestPause ? "Resume" : "Pause" } Test</button>
          </Col>
          <Col xs>
              <button type="button" className = { `btn btn__white ${ props.assessment && (props.assessment.status === ASSESSMENT_STATUSES.COMPLETED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_QUESTIONNIRE) && "disabled" } ${!!props.assessment?.status == false  && "disabled"}` } onClick = { handleCancel } disabled = { props.assessment && (props.assessment.status === ASSESSMENT_STATUSES.COMPLETED || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BP || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.START_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_PRE_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_QUESTIONNIRE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BP || props.assessment.status === ASSESSMENT_STATUSES.START_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_BASELINE || props.assessment.status === ASSESSMENT_STATUSES.STOP_POST_QUESTIONNIRE) }>Cancel Test</button>
          </Col>
        </Row>
      </div>
    </div>
  )
}

const mapStateToProps = ({ hmdDevices, assessment }) => ({
  assessment: assessment.activeAssessment,
  processedData: assessment.activeAssessmentProcessedData,
  hmdDeviceList: hmdDevices.hmdDeviceList || [],
  hmdById: hmdDevices.hmdById || null,
  hmdAssignedAssessment: hmdDevices.hmdAssignedAssessment || null,
  selectedHmdDevice: hmdDevices.selectedHmdDevice || null,
  trialInProgress: assessment.trialInProgress,
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({ 
    stopVFTById,
    getAssessmentById,
    setHmdDeviceById,
    getHmdDeviceById,
    setModalWithType,
    cancelAssessmentById,
    resumeAssessmentById,
    pauseAssessmentById,
    startAssessment
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(HomePanel)